const stripPWrapper = (raw) => {
  const s = (raw || '').trim();
  return /^<p\b[^>]*>([\s\S]*?)<\/p>$/i.test(s)
    ? s.replace(/^<p\b[^>]*>([\s\S]*?)<\/p>$/i, '$1').trim()
    : s;
};

export const parseJsonArray = (raw) => {
  try { return JSON.parse(stripPWrapper(raw)) || []; }
  catch { return []; }
};

export const parseJsonObject = (raw) => {
  try { return JSON.parse(stripPWrapper(raw)) || {}; }
  catch { return {}; }
};
